/**
 * GSAP animations for hhm-cta-section: scroll-triggered staggered content reveal.
 */
(function () {
	'use strict';

	function init() {
		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
		gsap.registerPlugin(ScrollTrigger);

		const section = document.querySelector('.hhm-cta-section');
		if (!section) return;

		const content = section.querySelector('.hhm-cta-section__content');
		if (!content) return;

		const title = content.querySelector('.hhm-cta-section__title');
		const desc = content.querySelector('.hhm-cta-section__desc');
		const btn = content.querySelector('.hhm-cta-section__btn');
		const contentEls = [title, desc, btn].filter(Boolean);

		if (!contentEls.length) return;

		const easeSnappy = 'power2.out';

		gsap.set(contentEls, { opacity: 0, y: 28 });
		gsap.to(contentEls, {
			opacity: 1,
			y: 0,
			duration: 0.65,
			stagger: 0.12,
			ease: easeSnappy,
			scrollTrigger: {
				trigger: content,
				start: 'top 82%',
				toggleActions: 'play none none none',
			},
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
